import { configureStore } from "@reduxjs/toolkit";
import projectsReducer from "./slices/projectsSlice";
import dialogsReducer from "./slices/dialogsSlice";

export const store = configureStore({
    reducer: {
        projects: projectsReducer,
        dialogs: dialogsReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
